export const LAST_ACTION_QUANTITY = 6;
